// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__gridContainer--kI8Em {
  display: grid;
  height: 100%;
  overflow: auto;
}
.style__empty--c39VT {
  height: auto;
}
.style__grid--sFKOX {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}
.style__grid--sFKOX > div:not(.style__gridColFixedRight--MY1iB) {
  width: inherit;
}
.style__gridItemHeader--P1S4S {
  background-color: #f1f2f4;
  color: #0c0d0d;
  font-weight: 600;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  position: sticky;
  top: 0;
  margin: 0;
  padding: 0 0.8rem;
  text-align: left;
  z-index: 1;
  min-width: 3rem;
}
.style__gridItemHeader--P1S4S div {
  display: flex;
}
.style__gridItemHeader--P1S4S svg {
  fill-opacity: 0.55;
}
.style__gridCol--POK2C {
  flex: 1;
}
.style__gridItem--kRbPY {
  color: #0c0d0d;
  display: flex;
  align-items: center;
  height: 3.375rem;
  border-bottom: 1px solid #d7d9da;
  margin: 0;
  padding: 0 1rem;
  text-align: left;
  background-color: #fff;
  min-width: 4rem;
  justify-content: flex-start;
}
.style__gridItem--kRbPY:hover .style__link--Ile73 {
  text-decoration: underline;
}
.style__gridItemCenter--uvr8M {
  justify-content: center;
}
.style__gridColFixedRight--MY1iB {
  text-align: center;
  max-width: 6rem;
  position: sticky;
  z-index: 1;
}
.style__gridCOLUMNFixed0--vqzmQ {
  right: 0;
}
.style__gridCOLUMNFixed1--wRcdu {
  right: 4rem;
}
.style__gridCOLUMNFixed2--lCiwg {
  right: 8rem;
}
.style__gridCOLUMNFixed3--XW1iN {
  right: 12rem;
}
.style__gridCOLUMNSmall0--T2DFX {
  width: 3rem !important;
  flex: 0;
}
.style__gridCOLUMNShadow--AasRa {
  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(12, 13, 13, 0.1), 0 0 0.25rem -0.125rem rgba(12, 13, 13, 0.06);
  box-shadow: 0 4px 8px -2px rgba(12, 13, 13, 0.1), 0px 0px 4px -2px rgba(12, 13, 13, 0.06);
}
.style__caretDown--JeK_7 {
  transform: rotate(180deg);
}
.style__sortCaretButton--ARm2W {
  display: flex;
  align-items: center;
}
.style__sortCaretInactive--v3iyL {
  opacity: 0.35;
}
.style__box--ppwim {
  margin: 1rem;
  display: flex;
  justify-content: space-between;
}
.style__box--ppwim > h5 {
  margin-top: 0;
}
.style__hidden--IQUao {
  display: none;
}
.style__hoverRow--y2lkc {
  background-color: #e3e8e5;
}
.style__hoverRow--y2lkc .style__hidden--IQUao {
  display: flex;
}
.style__hoverRow--y2lkc .style__hidden--IQUao > svg {
  cursor: pointer;
}
.style__ellipsis--heI1Y {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media only screen and (max-width: 1140px) {
  .style__ellipsisTooltip--_U07a {
    width: 60px;
  }
}
.style__click--WcH7J:hover {
  cursor: pointer;
  text-decoration: underline;
}
.style__searchBar--MFt4u > form > div {
  background-color: #fff;
}
.style__pointer--k10uV {
  cursor: pointer;
}
.style__gridItem0--WbaU4 {
  color: #0c0d0d;
  min-width: 12rem;
}
@media only screen and (max-width: 1140px) {
  .style__gridItem0--WbaU4 {
    min-width: 4rem;
  }
}
.style__inline--gfFIA {
  display: inline;
}
.style__inactive--nTSAD > * {
  color: #0c0d0d !important;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Grid/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,YAAA;EACA,cAAA;AAHJ;AADA;EAQI,YAAA;AAJJ;AAJA;EAYI,aAAA;EACA,iBAAA;EACA,WAAA;AALJ;AATA;EAiBM,cAAA;AALN;AAZA;EAsBI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAPJ;AA7BA;EAuCM,aAAA;AAPN;AAhCA;EA2CM,kBAAA;AARN;AAnCA;EAgDI,OAAA;AAVJ;AAtCA;EAoDI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;AAXJ;AAaI;EAEI,0BAAA;AAZR;AAtDA;EAwEI,uBAAA;AAfJ;AAzDA;EA4EI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAhBJ;AA/DA;EAmFI,QAAA;AAjBJ;AAlEA;EAuFI,WAAA;AAlBJ;AArEA;EA2FI,WAAA;AAnBJ;AAxEA;EA+FI,YAAA;AApBJ;AA3EA;EAmGI,sBAAA;EACA,OAAA;AArBJ;AA/EA;ECUE,0GAAA;EAKA,yFAAA;ADoEF;AAnFA;EA4GI,yBAAA;AAtBJ;AAtFA;EAgHI,aAAA;EACA,mBAAA;AAvBJ;AA1FA;EAqHI,aAAA;AAxBJ;AA7FA;EAyHI,YAAA;EACA,aAAA;EACA,8BAAA;AAzBJ;AAlGA;EA8HM,aAAA;AAzBN;AArGA;EAmII,aAAA;AA3BJ;AAxGA;EAuII,yBAAA;AA5BJ;AA3GA;EAyIM,aAAA;AA3BN;AA9GA;EA4IQ,eAAA;AA3BR;AAjHA;EAkJI,gBAAA;EACA,mBAAA;EACA,uBAAA;AA9BJ;AAiCE;EAAA;IAEI,WAAA;EA/BJ;AACF;AA3HA;EA8JI,eAAA;EACA,0BAAA;AAhCJ;AA/HA;EAoKM,sBAAA;AAlCN;AAlIA;EAyKI,eAAA;AApCJ;AArIA;EA6KI,cAAA;EACA,gBAAA;AArCJ;AAuCI;EAAA;IACE,eAAA;EApCJ;AACF;AA9IA;EAsLI,eAAA;AArCJ;AAjJA;EA2LM,yBAAA;AAvCN","sourcesContent":["@import '../colors';\n@import '../shadows';\n\n:local {\n  .gridContainer {\n    display: grid;\n    height: 100%;\n    overflow: auto;\n  }\n\n  .empty {\n    height: auto;\n  }\n\n  .grid {\n    display: flex;\n    flex-wrap: nowrap;\n    width: 100%;\n\n    > div:not(.gridColFixedRight) {\n      width: inherit;\n    }\n  }\n\n  .gridItemHeader {\n    background-color: @color-asphalt-grey-095;\n    color: @color-asphalt-grey-005;\n    font-weight: 600;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.25rem;\n    position: sticky;\n    top: 0;\n    margin: 0;\n    padding: 0 0.8rem;\n    text-align: left;\n    z-index: 1;\n    min-width: 3rem;\n\n    div {\n      display: flex;\n    }\n\n    svg {\n      fill-opacity: 0.55;\n    }\n  }\n\n  .gridCol {\n    flex: 1;\n  }\n\n  .gridItem {\n    color: @color-asphalt-grey-005;\n    display: flex;\n    align-items: center;\n    height: 3.375rem;\n    border-bottom: 1px solid @color-asphalt-grey-085;\n    margin: 0;\n    padding: 0 @spacing-100;\n    text-align: left;\n    background-color: @color-white;\n    min-width: 4rem;\n    justify-content: flex-start;\n\n    &:hover {\n      .link {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .gridItemCenter {\n    justify-content: center;\n  }\n\n  .gridColFixedRight {\n    text-align: center;\n    max-width: 6rem;\n    position: sticky;\n    z-index: 1;\n  }\n\n  .gridCOLUMNFixed0 {\n    right: 0;\n  }\n\n  .gridCOLUMNFixed1 {\n    right: 4rem;\n  }\n\n  .gridCOLUMNFixed2 {\n    right: 8rem;\n  }\n\n  .gridCOLUMNFixed3 {\n    right: 12rem;\n  }\n\n  .gridCOLUMNSmall0 {\n    width: @spacing-300 !important;\n    flex: 0;\n  }\n\n  .gridCOLUMNShadow {\n    .sys-elevation-shadow-level2;\n  }\n\n  .caretDown {\n    transform: rotate(180deg);\n  }\n\n  .sortCaretButton {\n    display: flex;\n    align-items: center;\n  }\n\n  .sortCaretInactive {\n    opacity: 0.35;\n  }\n\n  .box {\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n\n    > h5 {\n      margin-top: 0;\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n\n  .hoverRow {\n    background-color: @color-pewter-grey-090;\n    .hidden {\n      display: flex;\n\n      > svg {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .ellipsis {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  @media only screen and (max-width: 1140px) {\n    .ellipsisTooltip {\n      width: 60px;\n    }\n  }\n\n  .click:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n\n  .searchBar {\n    > form > div {\n      background-color: @color-white;\n    }\n  }\n\n  .pointer {\n    cursor: pointer;\n  }\n\n  .gridItem0 {\n    color: @color-asphalt-grey-005;\n    min-width: 12rem;\n\n    @media only screen and (max-width: 1140px) {\n      min-width: 4rem;\n    }\n  }\n\n  .inline {\n    display: inline;\n  }\n\n  .inactive {\n    > * {\n      color: @color-asphalt-grey-005 !important;\n    }\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `style__gridContainer--kI8Em`,
	"empty": `style__empty--c39VT`,
	"grid": `style__grid--sFKOX`,
	"gridColFixedRight": `style__gridColFixedRight--MY1iB`,
	"gridItemHeader": `style__gridItemHeader--P1S4S`,
	"gridCol": `style__gridCol--POK2C`,
	"gridItem": `style__gridItem--kRbPY`,
	"link": `style__link--Ile73`,
	"gridItemCenter": `style__gridItemCenter--uvr8M`,
	"gridCOLUMNFixed0": `style__gridCOLUMNFixed0--vqzmQ`,
	"gridCOLUMNFixed1": `style__gridCOLUMNFixed1--wRcdu`,
	"gridCOLUMNFixed2": `style__gridCOLUMNFixed2--lCiwg`,
	"gridCOLUMNFixed3": `style__gridCOLUMNFixed3--XW1iN`,
	"gridCOLUMNSmall0": `style__gridCOLUMNSmall0--T2DFX`,
	"gridCOLUMNShadow": `style__gridCOLUMNShadow--AasRa`,
	"caretDown": `style__caretDown--JeK_7`,
	"sortCaretButton": `style__sortCaretButton--ARm2W`,
	"sortCaretInactive": `style__sortCaretInactive--v3iyL`,
	"box": `style__box--ppwim`,
	"hidden": `style__hidden--IQUao`,
	"hoverRow": `style__hoverRow--y2lkc`,
	"ellipsis": `style__ellipsis--heI1Y`,
	"ellipsisTooltip": `style__ellipsisTooltip--_U07a`,
	"click": `style__click--WcH7J`,
	"searchBar": `style__searchBar--MFt4u`,
	"pointer": `style__pointer--k10uV`,
	"gridItem0": `style__gridItem0--WbaU4`,
	"inline": `style__inline--gfFIA`,
	"inactive": `style__inactive--nTSAD`
};
export default ___CSS_LOADER_EXPORT___;
